const video = document.querySelectorAll('video');

function addSourceToVideo(element, src) {
    let source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    element.appendChild(source);
}

function whichSizeVideo(element, src) {
    let windowWidth = window.innerWidth ? window.innerWidth : window.outerWidth;
    if (windowWidth > 700) {
        addSourceToVideo(element, src.dataset.desktopVid);
    } else {
        addSourceToVideo(element, src.dataset.mobileVid);
    }
}

function videoSize() {
    if (video !== undefined)
        video.forEach((element) => whichSizeVideo(element, element));
}

videoSize();
